import { object, string } from "yup";

let contactSchema = object({
  title: string().required("Title cannot be empty."),
  message: string().required("Message cannot be empty."),
});

export default contactSchema;
